import React from 'react';
import { PropTypes, describe } from 'react-desc';
import styled from 'styled-components';
import Chevron from '@elliemae/ds-icons/ChevronSmallDown';
import Button from '@elliemae/ds-button';

var Addon = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-1pazs35-0"
})(["background-color:transparent;padding-right:4px;height:100%;border:none;font-size:12px;font-weight:", ";color:", ";cursor:pointer;&:focus,&::after{background-color:transparent;box-shadow:none !important;border:none !important;}"], function (props) {
  return props.theme.fontWeights.semibold;
}, function (props) {
  return props.theme.colors.brand['700'];
});

var ActionAddon = function ActionAddon(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      icon = _ref.icon;
  return /*#__PURE__*/React.createElement(Addon, {
    onClick: onClick,
    labelText: label,
    icon: icon || /*#__PURE__*/React.createElement(Chevron, {
      color: ['brand-primary', 700]
    })
  });
};

var actionProps = {
  /**
   * Addon label
   */
  label: PropTypes.string.description('Addon label'),

  /**
   * On click callback
   */
  onClick: PropTypes.func.description('On click callback'),

  /**
   * Icon to display after the label
   */
  icon: PropTypes.element.description('Icon to display after the label')
};
ActionAddon.propTypes = actionProps;
var DSCardActionAddonWithSchema = describe(ActionAddon);
DSCardActionAddonWithSchema.propTypes = actionProps;

export default ActionAddon;
export { ActionAddon, DSCardActionAddonWithSchema };
//# sourceMappingURL=ActionAddon.js.map
